import styled from 'styled-components';
import reset from '../reset';
import em from '../em';

export default styled.div`
  ${reset()}
  margin-top: ${em(.3)};
  color: ${props => props.theme.hintColor};
  font-size: ${em(.75)};
`;
